import * as React from "react";
import { InView } from "react-intersection-observer";
import loadScriptWhenReady from "../../utils/load-script";

const LoadGoogleMapsJSApi = ({ googleMapsApiKey, processNodeEnv }) => {
  const loadMapsScript = (inView) => {
    if (!inView || typeof document === "undefined") return;

    const isSrcAlreadyLoaded = document.getElementById("gmaps-script");
    const googleMapsApi = "https://maps.googleapis.com/maps/api/js";
    const src = `${googleMapsApi}?key=${googleMapsApiKey}&libraries=places,geometry&channel=4&fields=formatted_address,geometry,address_components`;

    if (isSrcAlreadyLoaded) return;

    loadScriptWhenReady({ src, id: "gmaps-script", processNodeEnv });
  };

  return (
    <InView
      as="div"
      onChange={loadMapsScript}
      rootMargin="500px"
      style={{ height: "0" }}
      triggerOnce
      className="gmap-loader OneLinkTx"
    />
  );
};

export default LoadGoogleMapsJSApi;
